<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
         <!-- Bookmarks Container -->
        <b-link v-if="isMobile()" class="" to="/" >
          <b-img
            style="max-height:23px; margin-bottom: 1px; margin-left: 8px;"
            :src="appLogoImage1"
            alt="logo"
          />
      </b-link> 
       
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

      <!-- Bookmarks Container -->
      <b-link class="navbar-brand" to="/" >
        <b-img
          style="max-height:20px;"
          :src="appLogoImage2"
          alt="logo"
        />

      </b-link>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BImg
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    // App Name
    const { appName, appLogoImage2, appLogoImage1 } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage2,
      appLogoImage1,
    }
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
  }
}
</script>
